import * as i0 from '@angular/core';
import { NgModule, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { TuiRoot } from '@taiga-ui/core';
import { withUpdatedLang } from '@noda-lib/assets/localize';
import { getProviderKey, provideCustomFileOptions } from '@noda-lib/assets/tools';
import { NG_EVENT_PLUGINS } from '@taiga-ui/event-plugins';
import { secretReplacer } from '@noda-lib/utils/handlers';
let AssetsRootModule = /*#__PURE__*/(() => {
  class AssetsRootModule {
    static {
      this.ɵfac = function AssetsRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AssetsRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AssetsRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [TuiRoot]
      });
    }
  }
  return AssetsRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ASSETS_CDN_URL = new InjectionToken('ASSETS_CDN_URL', {
  factory() {
    return secretReplacer('https://{{secret}}.blob.core.windows.net', 'default');
  }
});
function withCdnUrl(url) {
  const providerKey = getProviderKey(url);
  return [{
    provide: ASSETS_CDN_URL,
    [providerKey]: url
  }];
}
function provideAssetsLibrary(...features) {
  return makeEnvironmentProviders([NG_EVENT_PLUGINS, withUpdatedLang(), provideCustomFileOptions(), ...features]);
}

/*
 * Public API Surface of assets
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ASSETS_CDN_URL, AssetsRootModule, provideAssetsLibrary, withCdnUrl };
